import type { ReactNode } from 'react';
import { PackageOpen } from 'lucide-react';

export function EmptyState({
  icon,
  title,
  description,
  action,
}: {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
      <div className="text-night-blue/30">{icon ?? <PackageOpen size={48} strokeWidth={1.5} />}</div>
      <h3 className="font-condensed text-xl font-bold text-night-blue">{title}</h3>
      {description && <p className="max-w-sm text-sm text-night-blue/70">{description}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
